<script lang="ts" setup>
import { type OtButtonVariant } from '@1trading/design-system';
import { inject, ref, type PropType } from 'vue';

import { BalanceDisplayType, balanceService } from '@exchange/libs/balances/service/src';

defineProps({
  buttonVariant: { type: String as PropType<OtButtonVariant>, default: 'clear' },
});

const { setBalanceDisplayType } = balanceService;

const balanceMasked = inject('balanceMasked', ref(false));

const onSetMasked = () => {
  setBalanceDisplayType(balanceMasked.value ? BalanceDisplayType.FIAT : BalanceDisplayType.HIDDEN);
};
</script>

<template>
  <x-button
    class="privacy-button"
    :variant="buttonVariant"
    size="2xs"
    @click="onSetMasked"
  >
    <ot-icon
      :key="String(balanceMasked)"
      class="privacy-button__icon"
      :name="balanceMasked ? 'eye-slash' : 'eye'"
    />
  </x-button>
</template>

<style lang="scss">
.privacy-button {
  color: rgb(var(--v-theme-text-secondary)) !important;

  &__icon {
    width: 20px;
  }
}
</style>
